import { Component, ViewChild, OnInit,OnChanges,Output,EventEmitter } from '@angular/core';
import { RouterModule,Router,ActivatedRoute } from '@angular/router';
import { DialogBoxComponent } from './dialog/dialog-box.component';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { EvaluacionService } from '../../services/evaluacion.service';
import { Consolidacion } from 'app/main/models/consolidacion.model';
import { Riesgo } from 'app/main/models/riesgo.model';
import { Evaluacion } from 'app/main/models/evaluacion.model';
import { FactorPonderacionService } from '../../services/factor-ponderacion.service';
import { getUsuariosNodo } from 'app/main/models/nodo-estructura-jerarquica.model';
import { SelectObjetivoDialogBoxComponent } from 'app/main/apps/objetivos/dialog-objetivo/select-objetivo-dialog-box.component';
import { DialogBoxComponentObjetivo } from 'app/main/apps/objetivos/dialog-objetivo/dialog-box.component';
import { SelectUsuarioDialogBoxComponent } from 'app/main/apps/usuarios/dialog/select-usuario-dialog-box.component';
import { SelectDimensionDialogBoxComponent} from 'app/main/apps/dimensiones-riesgos/dialog/select-dimension-dialog-box.component';
import { DialogBoxComponentDimension } from 'app/main/apps/dimensiones-riesgos/dialog/dialog-box.component';
import {SelectObjetivoRiesgoDialogBoxComponent } from 'app/main/apps/riesgo/dialog/select-objetivo-riesgo-dialog-box.component';
import {AddAInherenteDialogBoxComponent}  from 'app/main/apps/riesgo/dialog/add-a-inherente-dialog-box.component';
import {AddAResidualDialogBoxComponent}  from 'app/main/apps/riesgo/dialog/add-a-residual-dialog-box.component';
import {AddControlSugeridoDialogBoxComponent} from 'app/main/apps/control/dialog/add-control-sugerido-dialog-box.component';
import { AddKriDialogBoxComponent } from 'app/main/apps/kri/dialog/add-kri-dialog-box.component';
import { AddMedidaDeContingenciaDialogBoxComponent} from './dialog/add-medidas-de-contingencia-dialog-box.component';
import { UsersService } from '../../services/users.service';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import {FormBuilder, FormGroup,FormControl, Validators} from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import { DialogBoxPrintComponentEvaluacionConsolidadaDetallada } from './dialog/dialog-consolidacion-print-box.component';
import { MatDrawer } from '@angular/material/sidenav';
//import {parse, stringify} from 'flatted';


//import { formatLabel, escapeLabel } from '@swimlane/ngx-charts/common/label.helper';
import * as d3 from 'd3-selection';

const Parser = require('expr-eval').Parser;


@Component({
    selector   : 'consolidacion-view',
    templateUrl: './consolidacion-view.component.html',
    styleUrls  : ['./consolidacion-view.component.scss']
})
export class ConsolidacionViewComponent implements OnInit,OnChanges
{
    //Cart Date
    multi: any[];
    view: any[] = [700, 350];

    dataSource = [];
    dataSourceI = [];
    dataSourceR = [];
    resultsList = [];

    pieDataExposiciones = [];

    legend: boolean = true;
    showLabels: boolean = true;
    animations: boolean = true;
    xAxis: boolean = true;
    yAxis: boolean = true;
    showYAxisLabel: boolean = true;
    showXAxisLabel: boolean = true;
    xAxisLabel: string = 'Probabilidad';
    yAxisLabel: string = 'Impacto';
    gradient: boolean = false;

    colorScheme = {
      domain: ['#34C229', '#F1F80C','#E44D25']
    };

    customColors = [];
    customColorsPie = [];

    displayedColumnsObjetivos: string[] = ['nombre', 'descripcion'];
    displayedColumnsUsuarios: string[] = ['nombre', 'correoElectronico'];
    displayedColumnsDimensiones: string[] = ['nombre', 'descripcion','categorias'];
    displayedColumnsRiesgos: string[] = ['objetivo', 'riesgo'];
    displayedColumnsAnalisisResidual : string[] = ['evaluacion','objetivo', 'riesgo','probabilidad','impacto','factor','impactoPonderado','exposicion','clasificacion'];
    displayedColumnsEvaluaciones: string[] = ['nombre','version','estructuraJerarquica','creador','dueno','fechaInicio','fechaFin','action'];

    isEditable = false;
    isReseted = false;

    nombre:string = "";
    consolidacion : Consolidacion = null;
    id :number = null;
    is_eval_creador: boolean = false;
    editar_nombre: boolean = false;
    editar_tipo:boolean = false;
    editar_estructura:boolean = false;
    editar_dueno: boolean = false;
    editar_fecha_inicio: boolean = false;
    editar_fecha_fin: boolean = false;
    tipos = ["EVALUACION","OBJETIVO"];
    estructuraJerarquicas = [];
    nodosEstructuraJerarquica = [];
    factoresPonderacion = [];
    usuarios = [];
    riesgos = [];
    riesgosAgregados = [];
    riesgosTooltip = {};
    role = null;
    is_eval_owner = false;
    actualizo_heatmap = false;

    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @ViewChild('tableAInherente', {static: true}) tableAInherente: MatTable<any>;
    @ViewChild('stepper') private stepper: MatStepper;
    @Output() selectedTabChange: EventEmitter<MatTabChangeEvent>

    //@ViewChild("stepper") stepper: MatStepper;


    constructor(public dialog: MatDialog,
                public serviceFactorEvaluacion:FactorPonderacionService,
                private storage: TokenStorageService,
                private service: EvaluacionService,
                private _snackBar: MatSnackBar,
                public translate: TranslateService,
                private _formBuilder: FormBuilder,
                public router: Router,
                private route: ActivatedRoute) {}


    ngOnInit() {
      this.route.paramMap.subscribe(params => {
          this.id = parseInt(params.get('id'), 10);

          this.service.getConsolidacion(this.id).pipe().subscribe(req => {
            this.consolidacion = new Consolidacion(req.body);
            var user = this.storage.getUser();
            this.role = this.storage.getRole();

            if(this.consolidacion.creador.correoElectronico.trim() == user.trim()){
                this.is_eval_creador = true;
            }

            if(this.consolidacion.responsable.correoElectronico.trim() == user.trim()){
                  this.is_eval_owner = true;
            }

            this.dataSource = this.consolidacion.escenario.probabilidades || [];
            this.dataSourceI = this.consolidacion.escenario.impactos || [];

            this.consolidacion.evaluaciones.forEach(evaluacion => {

              evaluacion.riesgos.forEach(riesgo => {
                riesgo.evaluacion = new Evaluacion({});
                riesgo.evaluacion.id= evaluacion.id;
                riesgo.evaluacion.nombre = evaluacion.nombre;
                riesgo.nombre = evaluacion.nombre;

                riesgo.analisisResidual.forEach(ar => {
                  if(riesgo.topAnalisisResidual==null){
                    riesgo.topAnalisisResidual= ar;
                  }else if(riesgo.topAnalisisResidual.exposicion>ar.exposicion){
                    riesgo.topAnalisisResidual= ar;
                  }
                  this.calcularNuevaExposicion(riesgo);
                  riesgo.impactoPonderado = riesgo.topAnalisisResidual.impacto.valor * riesgo.factor.factor;
                  
                });
                this.riesgos.push(riesgo);
              });
            });

            this.calcularResultadosOriginal();

          });

          this.serviceFactorEvaluacion.getAll(0,1000).pipe().subscribe(req => {
            this.factoresPonderacion = req.body.map( tipo => {
              console.log(tipo);
              return {
                id: tipo.id,
                nombre: tipo.nombre
              };
            });
          });

      });


    }

    ngAfterViewChecked(){
      //this.actualizarColores();
    }

    ngOnChanges() {
      //this.actualizarColores();
    }


    navegateTo(url): void  {
        this.router.navigateByUrl(url).then( (e) => {
          if (e) {
            console.log("Navigation is successful!");
          } else {
            console.log("Navigation has failed!");
          }
        });
    }

    openDialog(): void {
      var obj = {};
      const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
        width: '100%',
        data: obj,
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {

        this.service.editEstructura(this.consolidacion.id,
          {estructura:result.data.estructura,nodo:result.data.nodo}).pipe().subscribe(req => {
            this.consolidacion.nodoEstructuraJerarquica = result.data.nodo;
            this.consolidacion.estructuraJerarquica = result.data.estructura;
            this.consolidacion.responsable = null;
        },
        err => {
          this.openSnackBar("No se pudo modificar la estructura, ocurrió un error.","Cerrar");
        });

      });
    }

    print():void{

      const dialogRef = this.dialog.open(DialogBoxPrintComponentEvaluacionConsolidadaDetallada, {
        width: '100%',
        data: {action:"Print", obj:{evaluacion:this.consolidacion,riesgos:this.riesgos}},
        autoFocus: false,
        disableClose: true
      });

    }


    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 3000,
      });
    }

    calcularNuevaExposicion(riesgo):void{

      var factor = {id:null,factor:1};
      if(this.consolidacion.tipo == 'EVALUACION'){

        var evaluacionPonderado = this.obtenerEvaluacionPonderado(riesgo.evaluacion);
        if(evaluacionPonderado!=null)
          factor = evaluacionPonderado.factor;
      }

      if(this.consolidacion.tipo == 'OBJETIVO'){

        var objetivoPonderado = this.obtenerObjetivoPonderado(riesgo.objetivo);
        if(evaluacionPonderado!=null)
          factor = objetivoPonderado.factor;
      }

      riesgo.factor = factor;

      this.calcularExposicion(riesgo,factor);


    }


    obtenerEvaluacionPonderado(evaluacion):any{
      var ponderacion = null;
      this.consolidacion.ponderacionesPorEvaluacion.forEach(ponderacionR => {

        if(evaluacion.id == ponderacionR.evaluacion.id){
          ponderacion = ponderacionR;
        }
      });

      return ponderacion;
    }

    obtenerObjetivoPonderado(objetivo):any{
      var ponderacion = null;
      this.consolidacion.ponderacionesPorObjetivo.forEach(ponderacionR => {

        if(objetivo.id == ponderacionR.objetivo.id){
          ponderacion = ponderacionR;
        }
      });

      return ponderacion;
    }

    calcularExposicion(riesgo,factor){

      const parser = new Parser();
      var expression = parser.parse(this.consolidacion.escenario.formulaDeExposicion);
      var exposicion = expression.evaluate({ P: riesgo.topAnalisisResidual.probabilidad.valor, I: riesgo.topAnalisisResidual.impacto.valor*factor.factor });
      riesgo.topAnalisisResidual.exposicion = exposicion;

      var clasificacion = "Aceptable";
      if(exposicion>=this.consolidacion.escenario.apetito)
        clasificacion = "Atención";

      if(exposicion>=this.consolidacion.escenario.tolerancia)
        clasificacion = "Inaceptable";

      riesgo.topAnalisisResidual.clasificacion = clasificacion;
    }

    selectFactor():void{

    }


    calcularResultadosOriginal(){

        console.log("Entro a calcularResultadosOriginal para actualizar los resultados");
        this.dataSourceR = [];
        this.multi = [];

        this.dataSourceI.sort((a, b) => (a.valor > b.valor) ? 1 : -1);
        this.dataSourceI = [...this.dataSourceI];
        this.dataSource.sort((a, b) => (a.valor > b.valor) ? 1 : -1);
        this.dataSource = [...this.dataSource];
        this.customColors = [];

        this.resultsList = [];

        for(var f=0; this.dataSource.length>f;f++){
          for(var x=0; this.dataSourceI.length>x;x++){
            const parser = new Parser();
            var expression = parser.parse(this.consolidacion.escenario.formulaDeExposicion);
            var result = expression.evaluate({ P: this.dataSource[f].valor, I:this.dataSourceI[x].valor });
            this.resultsList.push(result);
          }
        }

        if(this.consolidacion.escenario.formulaDeExposicion!=null){

          for(var i=0; this.dataSource.length>i;i++){

              var chartV ={"name": this.dataSource[i].nombre +" ("+this.dataSource[i].valor+")",
                            "series": []
                            };

            for(var z=0; this.dataSourceI.length>z;z++){
              const parser = new Parser();
              //let expr = parser.parse('2 * x + 1');
              //console.log(expr.evaluate({ x: 3 })); // 7
              var expression = parser.parse(this.consolidacion.escenario.formulaDeExposicion);
              var result = expression.evaluate({ P: this.dataSource[i].valor, I:this.dataSourceI[z].valor });
              this.dataSourceR.push({probabilidad:this.dataSource[i], impacto:this.dataSourceI[z],resultado:result});
              var nombre_evaluacion = (this.dataSourceI[z].nombre!=null && this.dataSourceI[z].nombre.length>50) ? this.dataSourceI[z].nombre.substring(0,50) +"..." : this.dataSourceI[z].nombre;

              result = Number(result.toFixed(2));

              chartV["series"].push({
                                    "name":nombre_evaluacion +" ("+this.dataSourceI[z].valor+")",
                                     "value":  result
                                   });
              var color = '#34C229';

              if(result>=this.consolidacion.escenario.apetito)
                color =  '#F1F80C';

              if(result>=this.consolidacion.escenario.tolerancia)
                color =  '#E44D25';

              this.customColors.push({"name":nombre_evaluacion +" ("+this.dataSourceI[z].valor+")","value":color});
              this.customColorsPie.push({"name":result.toString(),"value":color});
            }

            this.multi.push(chartV);
          }

          this.customColors = [...this.customColors];
          this.customColorsPie = [...this.customColorsPie];
          this.dataSourceR = [...this.dataSourceR];

          //this.updateChartTexts();
          //this.actualizarColores();

        }
    }

    async actualizarColores(){
      
      console.log("Entro a actualizarColores para actualizar los colores del tablero.");
      var elementosAActualizar = document.querySelectorAll('[ngx-charts-heat-map-cell]');

      if(!this.actualizo_heatmap && elementosAActualizar!=null && elementosAActualizar.length>0){
        
        this.calculateColorsValue();
        this.updateChartTexts();

      }else{
        if(!this.actualizo_heatmap){
          await this.delay(1000);
          this.actualizarColores();
        }
      }



    }

    delay(ms: number) {
      return new Promise( resolve => setTimeout(resolve, ms) );
    }

    
    tooltipText(data) {
      /* data = name:"Medio  (3)" //Impacto
                series:"Baja  (2)" //Probabilidad
                value: 2.6*/
  
      var impacto = Number(data.name.match(/\d+/)[0]);
      var probabilidad = Number(data.series.match(/\d+/)[0]);
  
      var textoTooltip = '';
  
      //var objetivos = this.contarObjetivosEntreValores(data.value);
      var cardinal = probabilidad +","+impacto;
      if(this.riesgosTooltip[cardinal]!=null)
  
         if(this.riesgosTooltip[cardinal]["probabilidad"] == probabilidad  &&
            this.riesgosTooltip[cardinal]["impacto"] == impacto){
  
          this.riesgosTooltip[cardinal]["riesgos"].forEach(element => {
            var nombre_evaluacion = (element.evaluacion.nombre!=null && element.evaluacion.nombre.length>75) ? element.evaluacion.nombre.substring(0,75) +"..." : element.evaluacion.nombre;
            var nombre_objetivo = (element.objetivo.nombre!=null && element.objetivo.nombre.length>75) ? element.objetivo.nombre.substring(0,75) +"..." : element.objetivo.nombre;
            var nombre_riesgo = (element.riesgo.nombre!=null && element.riesgo.nombre.length>75) ? element.riesgo.nombre.substring(0,75) +"..." : element.riesgo.nombre;
            textoTooltip+=`<span class="tooltip-label" >${nombre_evaluacion} - ${nombre_objetivo} - ${nombre_riesgo}</span>`;
          });
      }
  
      return textoTooltip;
    }

    updateChartTexts(){
      var width = 20,
        barHeight = 20;

      var chart = d3.select(".ngx-charts");
      var bar = chart.selectAll("g.cell");

      bar.append("text")
        .attr("dy", "1.65em")
        .attr("dx", "1em")
        .attr("class", "rec_text")
        .attr("style", "font-size:20px;")
        .text(function(d) {
          var val= this.parentNode.parentNode.getAttribute("ng-reflect-data");
          var cantidad = this.parentNode.parentNode.getAttribute("cantidad");

          return cantidad; });

          setTimeout(() =>
            {
                this.view= [700, 355];
            },
            1000);

    }

    contarCantidadEntreValores(result,iImpacto,iProbabilidad,resultados):number{

      resultados.sort((a, b) => (a > b) ? 1 : -1);
      var cantidad = 0;
      var min = 0;
      var max = result;

      for(var i=0;i<resultados.length;i++){
          if(resultados[i]==result){
            if(i==(resultados.length-1))
            max = 100000000;

            if(i>1){
              min= resultados[i-1];
              break;
            }

          }
      }

      result = Number(result);

      this.riesgos.forEach(riesgo => {

        //console.log("Riesgo exposicion: "+riesgo.topAnalisisResidual.exposicion+"Minimo: "+min+" Resultado: "+result );
        var pasa = false;
        if(riesgo.topAnalisisResidual!=null && riesgo.topAnalisisResidual.exposicion!=null)
          
        /*
          var resultExposicion = Number(riesgo.topAnalisisResidual.exposicion.toFixed(2));  
          if(resultExposicion>=min && resultExposicion<=max &&
              this.riesgosAgregados.indexOf(riesgo.id)==-1){
                pasa= true;
          }*/
          
          if(riesgo.topAnalisisResidual.probabilidad.valor==iProbabilidad && riesgo.topAnalisisResidual.impacto.valor==iImpacto &&
            this.riesgosAgregados.indexOf(riesgo.id)==-1){
              pasa= true;
          }

          if(pasa){
            cantidad+=1;
            console.log("Entro al Minimo: "+min+" Resultado: "+result+" con expo "+riesgo.topAnalisisResidual.exposicion );
            this.riesgosAgregados.push(riesgo.id);
            
            var cardinal = iProbabilidad +","+iImpacto;
            if(this.riesgosTooltip[cardinal]== null)
              this.riesgosTooltip[cardinal] = {"impacto": iImpacto, "probabilidad": iProbabilidad, "riesgos": []};

            this.riesgosTooltip[cardinal]["riesgos"].push(riesgo);
          }



      });

      return cantidad;

    }




    compareObjects(o1: any, o2: any): boolean {
      return o1.nombre === o2.nombre && o1.id === o2.id;
    }

    esOwnersGroup(usuario):boolean{

      var esOwner:boolean = false;

      usuario.tipos.forEach(element => {
        if(element.id == 4)
          esOwner = true;
      });

      return esOwner;
    }

    public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
      console.log(tabChangeEvent);
      console.log("Entro a tabChanged para actualizar los resultados");
      if(tabChangeEvent.tab.textLabel=="Análisis Residual"){
        this.actualizo_heatmap = false;
        this.actualizarColores();
      }
      //this.calcularResultadosOriginal();
    }

    updateName(nombre):void{}


    calculateColorsValue(){

      this.pieDataExposiciones = [];
      this.riesgosAgregados = [];
      var valoresYaEvaluados = [];
      this.riesgosTooltip = {};
      var elementosAActualizar = document.querySelectorAll('[ngx-charts-heat-map-cell]');
      console.log("Cantidad de nodos:"+ elementosAActualizar.length);
      var nodo = elementosAActualizar[0];
      var val= nodo.getAttribute('ng-reflect-data');
      console.dir("NO SE ENCONTRO NODO con 'ng-reflect-data'");
      console.dir(nodo);
      var iProbabilidad = 0;
      var iImpacto = 0;
      const parser = new Parser();
      var expression = parser.parse(this.consolidacion.escenario.formulaDeExposicion);
      for(var i = 0; i< elementosAActualizar.length;i++){

        nodo = elementosAActualizar[i];
        //console.dir(nodo);
        var colorRecuadro = this.customColors[i].value;
        nodo.children[0].children[0].setAttribute("fill",colorRecuadro);
        var probabilidadVal = this.consolidacion.escenario.probabilidades[iProbabilidad].valor;
        var impactoVal = this.consolidacion.escenario.impactos[iImpacto].valor;
        val= expression.evaluate({ P: probabilidadVal, I:impactoVal });
        
        var cantidad = 0;
        //Si no se evaluo aun ese valor.
        if(valoresYaEvaluados.indexOf(val)==-1){
          val = Number(val).toFixed(2);
          cantidad = this.contarCantidadEntreValores(val,impactoVal,probabilidadVal,this.resultsList);
          valoresYaEvaluados.push(val);
        }else{
          console.log("Valor ya evaluado:"+val);
        }

        nodo.setAttribute('cantidad',cantidad.toString());
        console.log("Valor: "+val+" cantidad del nodo: "+nodo.getAttribute('cantidad') + " cantidad encontrada:"+cantidad);

        if(cantidad>0)
          this.pieDataExposiciones.push({name:Number(val).toFixed(2).toString(),value:cantidad});

        iImpacto += 1;
        if(iImpacto>= this.consolidacion.escenario.impactos.length){
          iImpacto =0;
          iProbabilidad += 1;
        }

        this.pieDataExposiciones = [...this.pieDataExposiciones];
        this.actualizo_heatmap = true;
      }
    }

}
